import {
  Box,
  Button,
  Divider,
  Flex,
  FormLabel,
  Image,
  Input,
  Select,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { AiFillVideoCamera, AiOutlineCamera } from "react-icons/ai";
import { BsFillCameraFill } from "react-icons/bs";
import { ProfileInputField } from "./ProfileInputField";
import { updateProfile } from "./service";
import { useRef } from "react";

export const ProfileEdit = ({ user, setRefresh }) => {
  const containerBgColor = useColorModeValue("#f9fafc", "#020B19");
  const containerBorderColor = useColorModeValue("#e7e7e7", "#020b19");
  const bg1Style = useColorModeValue(
    { background: "#707070", border: "3px solid #E1E1E1" },
    {
      background: "#000000",
      border: "3px solid #676767",
      color: "#fff",
    }
  );

  const btnStyle = useColorModeValue(
    { bg: "#1392E6", boxShadow: "0px 2px 7px #1392e6" },
    {
      bg: "#0076FF",
      boxShadow: "0px 2px 7px #0076FF",
    }
  );

  const textLabelColor = useColorModeValue("#000", "#343434");
  const textLabelColor2 = useColorModeValue("#000", "#636363");

  const inputBgColor = useColorModeValue("#fff", "#000000");
  const inputColor = useColorModeValue("#343434", "#707070");

  const inputStyle = {
    //bg: "#000",
    color: {inputColor},
    _placeholder: { color: "#fff" },
    borderRadius: "20px",
    cursor: "pointer",
    //boxShadow: "2px 2px 9px 0px #80808021",
    fontWeight: "100",
    fontSize: ".8em",
    width: "100%",
  };
  
  const [formValues, setFormValues] = useState({
    name: user?.name,
    email: user?.email,
    username: user?.username,
    dob: user?.dob,
    //photo: user?.picture,
    account_type: user?.account_type,
  });

  const [loading, setLoading] = useState(false);
  const [img, setImg] = useState("");
  const [previewImg, setPreviewImg] = useState("");
  const imgRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("name", formValues?.name);
    formData.append("username", formValues?.username);
    formData.append("email", formValues?.email);
    img && formData.append("picture", img);
    // formData.append("photo", formValues?.photo)
    await updateProfile(formData, setLoading, setRefresh, user?.account_type);
  };

  const readURL = (file) => {
    //debugger;
    console.log('theFile: ', file)
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onload = (e) => res(e.target.result);
      reader.onerror = (e) => rej(e);
      reader.readAsDataURL(file);
    });
  };

  return (
    <Box
      border={`1px solid ${containerBorderColor}`}
      p="30px 40px 15px 40px"
      borderRadius={"10px"}
      textAlign="left"
      bg={containerBgColor}
      color="#343434"
      maxW={"750px"}
    >
      <Stack
        mb="20px"
        direction={["column", "column", "column", "row"]}
        alignItems={["center", "center", "center", "flex-start"]}
        justifyContent={"flex-start"}
      >
        <Flex
          
          justify={"center"}
          alignItems="center"
          borderRadius={"50%"}
          width="100px"
          height="100px"
          maxW="100px"
          {...bg1Style}
          mr="50px"
        >
          {previewImg || user?.picture ? (<Image
            w="100px"
            h="100px"
            maxW={"100px"}
            borderRadius={"50%"}
            objectFit="cover"
            fallbackSrc={user?.picture}
            src={previewImg}
            alt="user upload"
            onClick={() => imgRef.current.click()}
            cursor="pointer"
            //onChange={handleChange}
          />
          ) : (

          <Flex 
            direction={"column"} 
            align="center" 
            justify="center"
          >
            <BsFillCameraFill color="#fff" size={"1.5em"} />

            <FormLabel
              htmlFor="image"
              display={"inline-block"}
              color={"#fff"}
              fontSize=".66em"
              textAlign={"center"}
              overflow="hidden"
              mt="2px"
              ml="8px"
            >
              Click to change photo
            </FormLabel>

            {/* <Input
              //id="image"
              name={formValues?.photo}
              overflow={"hidden"}
              width={0}
              height={0}
              type="file"
              onChange={handleChange}
            /> */}
            
          </Flex>
          )}

          <Input
            ref={imgRef}
            id="image"
            display={"none"}
            name="img"
            width={0}
            height={0}
            type="file"
            accept="image/jpeg, image/jpg, image/png"
            onChange={async (e) => {
              setImg(e.target.files?.[0]);
              setPreviewImg(await readURL(e.target.files?.[0]));
              // try {
              //   const previewImageUrl = await readURL(e.target.files?.[0]);
              //   //console.log('previewImageUrl: ', previewImageUrl);
              //   setPreviewImg(previewImageUrl); // Update the image preview
              // } catch (error) {
              //   console.error(error);
              // }
            }}
          />
        </Flex>

        <Box>
          <Text color="#100DB1" fontSize={".9em"} fontWeight="bold" mb="20px">
            Account Details
          </Text>
          <ProfileInputField
            name={"name"}
            value={formValues?.name}
            label={"Name"}
            type="text"
            handleChange={(e) => handleChange(e)}
          />
          <ProfileInputField
            name={"username"}
            value={formValues?.username}
            label={"Username"}
            type="text"
            handleChange={handleChange}
          />
          <ProfileInputField
            name={"email"}
            value={formValues?.email}
            label={"Email"}
            type="email"
            handleChange={handleChange}
          />
          {/* <ProfileInputField
           
            name={"account_type"}
            value={formValues?.account_type}
            label={"Account Type"}
            type="text"
            handleChange={handleChange}
          /> */}

        <Select
          display={"none"}
          {...inputStyle}
          defaultValue={""}
          bg={inputBgColor}
          color={inputColor}
          //value={categoryText}
          //onChange={(e) => setSelectedCategory(e.target.value)}
          onChange={handleChange}
        >
          <option value="" style={{ color: '#718096' }}>
            Select Interest
          </option>
          {/* {categories?.length > 0 &&
            categories.map((cat, index) => (
              <option key={index} value={cat?.name} style={{ color: '#718096' }}>
                {cat?.name}
              </option>
          ))} */}
        </Select>
          <Button
            mt="10px"
            height="40px"
            {...btnStyle}
            color="#fff"
            width="320px"
            borderRadius={"25px"}
            isLoading={loading}
            onClick={handleUpdate}
            fontSize=".7em"
          >
            SAVE NEW CHANGES
          </Button>
        </Box>
      </Stack>
      <Divider mb="5px" />
      <Flex justify="flex-start" align={"center"} ml="150px" display={"none"}>
        <Text color="#100DB1" fontWeight={"bold"} fontSize=".9em">
          Security
        </Text>
      </Flex>
    </Box>
  );
};
